module.exports = __webpack_public_path__ + "img/svg/divider-long.7f9ec5e21cd2aabdf3c08e4d221b504c.svg";